import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { STORAGE } from "src/app/constant/storages";
import { AppService } from "src/app/services/app.service";
import { _deleteStorage, _getStorage } from "src/app/utils/local-storage";

@Component({
  selector: "app-manual-notaxinvoice",
  templateUrl: "./manual-notaxinvoice.page.html",
  styleUrls: ["./manual-notaxinvoice.page.scss"],
})
export class ManualNotaxinvoicePage implements OnInit {
  @Input() public acticeNotax: any;
  cardID = true;
  data: any;
  public appPages = [
    {
      title: "ค้นหาข้อมูลผู้ซื้อสินค้า",
      url: "/no-tax-invoice",
      icon: "mail",
      action: 1,
      checkroute: false,
    },
    {
      title: "ข้อมูลผู้ซื้อสินค้า",
      url: "/select-no-taxinvoice",
      icon: "paper-plane",
      action: 2,
      checkroute: false,
    },
    {
      title: "ค้นหาข้อมูลการซื้อสินค้า",
      url: "/check-no-taxinvoice",
      icon: "heart",
      action: 3,
      checkroute: false,
    },
    {
      title: "บันทึกและส่งข้อมูล",
      url: "/tax-invoice-search-buy",
      action: 4,
      checkroute: true,
    },
    {
      title: "ออกใบกำกับภาษีสำเร็จ",
      url: "/preview-no-taxinvoice",
      action: 5,
      checkroute: true,
    },
  ];

  constructor(
    public router: Router,
    private appService: AppService,
    public storage: Storage
  ) {
  }

  ngOnInit() {
    this.appService.active.subscribe((value) => {
      this.acticeNotax = value;
    });
  }
  ionViewDidEnter() {}

  ionViewWillLeave() {

      _deleteStorage(STORAGE.DATA_ADD_NO__TAXINVOICE)
      _deleteStorage(STORAGE.DATA_EDIT_NO__TAXINVOICE)
      _deleteStorage(STORAGE.DATA_PREVIEW_NO__TAXINVOICE)
  }

  clickMenu(a) {
    let data = _getStorage(STORAGE.DATA_SELECT_NO_TAXINVOICE)
    if (a.action === 1) {
      this.router.navigate([a.url], {
        queryParams: { noName: "no_tax", selectedIndex: "4" },
      });
    }

    if (a.action === 2) {
      if (data.length > 0) {
        this.router.navigate([a.url], {
          queryParams: { noName: "no_tax", selectedIndex: "4" },
        });
      } else {
        this.router.navigate([a.url]); this.router.navigate([a.url], {
          queryParams: { noName: "no_tax", selectedIndex: "4" },
        });
      }
    }
  }
}
